import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import axios from "axios";
import LocalStorageService from "../../utils/LocalStorageService";
import Constant, { url } from "../../utils/Constant";
import Loader from "../section/loader";
import UIkit from 'uikit';
import swal from "sweetalert";
import "../landing/landing.css"
import Cookies from "js-cookie";
// import swal from "sweetalert";
import { encrypt ,decrypt } from "../../utils/encryptiondecryption";
import { key } from "../../utils/encryptiondecryption";
import { isMobile } from "react-device-detect";



class GrameenBangladesh extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPackage: "17001", // Default radio option
      phoneNumber: "", // Default number input value
      hasError: "", //to check number is correct or not
      isDisabled: false, //if the form submit is in progress / api is taking time button is kept disabled
      packageList: [],
      isLoading: false,
      inputValue: "",
      iframe: "",
      isloaded: false,
      embededUrl: "",
      loginmobilenumber: "",
      click_id: "",
      user_id : '' ,
      mobile : '' ,
      package_id : '' ,
      telco : ''
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    console.log(this.state.telco)
    // this.getUserNumber();
    this.getPackages();
    this.checkUrl();
    // this.callloginapi();

    setTimeout(() => {
      this.setState({ isLoading: false });
      var swiper = new window.Swiper(".banner-slider", {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 2,
        loop: true,
        coverflowEffect: {
          rotate: 0,
          scale: 1.15,
          stretch: 300,
          depth: 300,
          modifier: 1,
          slideShadows: false,
        },
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
          },
          1024: {
            slidesPerView: 2,
          },
        },
      });
    }, 2000);
  }

  handleRadioChange = (event) => {
    this.setState({
      selectedPackage: event.target.value,
    });
    console.log(this.state.selectedPackage)
  };

  handleNumberChange = (event) => {

    if (/^\+?\d*$/.test(event.target.value)) {
      this.setState({
        phoneNumber: event.target.value,
      });
  }

   
  };

  handleSubmit = (event) => {
    event.preventDefault();
    let classRef = this;


    //if no telco selected then Return 
    if(this.state.telco === "") {
      swal({
        icon: "warning",
        title: "Please Select a Service Provider",
      })
      return
    }


    classRef.setState({ isDisabled: true });
    let phone = event.target.phoneBn.value;
    // console.log("phone", phone);



    function isValidBangladeshiPhoneNumber(phoneNumber) {
      // Regular expression for Bangladeshi phone numbers
      // const phoneRegex = /^(?:\+880|0)(?:\d{10}|\d{13})$/;
      // const phoneRegex = /^88017[0-9]{8}$/;
      const phoneRegex = /^8801[1-9][0-9]{8}$/;

      // Test the input phone number against the regex
      return phoneRegex.test(phoneNumber);
    }

    // Example usage:
    const phoneNumber1 = "+8801712345678";
    const phoneNumber2 = "01712345678";

    //   console.log("valid: ", isValidBangladeshiPhoneNumber(phone))

    if (isValidBangladeshiPhoneNumber(phone)) {
      classRef.setState({
        phoneNumber: phone,
        hasError: "",
      });


      axios({
        method: "POST",
        // if user selects Rubi option then rubi endpoint will hit 
        url:  this.state.telco === 'grameen' ? Constant.url + "getsubs-bd" : Constant.url + "getsubs-robi-bd" ,
        data: {
          serviceId: this.state.telco === 'grameen' ? this.state.selectedPackage : 'MJU595698',
          msisdn: this.state.phoneNumber,
          base_url : Constant.subscription_url +'/register'
          
        },
        headers: {
          Authorization: "bearer " + localStorage.getItem("access_token"),
        },
        timeout: 20000,
      }).then( (result)=> {
        classRef.setState({ isDisabled: false });
        if (result.status === 200) {
          let response = {};
          response["data"] = JSON.parse(
            LocalStorageService.decryptAes(result.data.eData)
          );
          classRef.myForm.reset();

          if(response.data.code === 200){
            const url = new URL(window.location.href);
            const clickId = url.searchParams.get('click_id');
            const aff_id = url.searchParams.get('aff_id');

            if(clickId){
              axios({
                method:"post",
                url :'https://cdn2.mjunoon.tv:9191/v2/tracking-bd?msisdn='+this.state.phoneNumber+'&aff_id='+aff_id+'&click_id='+clickId+'',
              })  
            }
            this.setState({telco : ''})
            window.location.href = (response.data.data);
          }
          
          else if(response.data.code === 202) {
            swal({
              icon: "success",
              title: "Login Successful",
            }).then( () => {
              console.log("test by yaseen",response.data.data.uid);
              const msg =  `device_id : ${response.data.data.device_id} ; 
                    phone_details : ${response.data.data.phone_details};
                    user_id : ${response.data.data.uid} ; 
                    mobile : ${response.data.data.mobile} ;
                    package_id : ${response.data.data.package_id};
                    subscription_expiry_datetime:  ${response.data.data.subscription_expiry_datetime} ;`
        
              // this.dataStore(msg)
              window.location.href = "https://bd.mjunoon.tv/?msisdn="+ LocalStorageService.encryptAes(response.data.data.mobile)
              

            } )
          }

          else {
            swal({
              icon: "error",
              title: "Error",
              text: response.data.message,
            })
          }
          // console.log("subscription api response: ", response.data);
          // window.location.href = (response.data.data);
          // classRef.setState({ embededUrl: response.data.data });
          // UIkit.modal("#modal-iframe").show();
          // debugger;
        }
        if (result.status === 400) {
          console.log("subscription api response failed");
        }
      });
    }
    
    else {
      swal({
        icon:"error" , 
        title : "Invalid Number"
      })
      classRef.setState({
        // hasError: "invalid number",
        isDisabled: false 
      });
    }



    // Retrieve values from state
    // const { selectedPackage, phoneNumber } = this.state;

    // classRef.myForm.reset();
  };




  dataStore = (message) => {
    const encryptedText = encrypt(message, key);
    Cookies.set(
      "YUTETOLPBG-ASY1BSBD#!ASDNMlPOS--_AWQQWyADIURYBDSF092B34BSDSEWEWFELPOWD",
      encryptedText,
      {
        expires: 1,
      }
    );
  };


  callloginapi = (event) => {

    event.preventDefault();
    axios({
      method :"POST" ,
      url : Constant.url + "login-bd" ,
      data : {
      mobile : this.state.loginmobilenumber,
      }
    }).then((res) =>{
      // console.log(this.state.loginmobilenumber)
      console.log(res.data)

      let response = [];
      response["data"] = JSON.parse(
        LocalStorageService.decryptAes(res.data.eData)
      );
      if(response.data.code === 200){  
      const msg =  `device_id : ${response.data.data.device_id} ; 
                    phone_details : ${response.data.data.phone_details};
                    user_id : ${response.data.data.uid} ; 
                    mobile : ${response.data.data.mobile} ;
                    package_id : ${response.data.data.package_id};
                    subscription_expiry_datetime:  ${response.data.data.subscription_expiry_datetime}
                    telco : ${response.data.data.telco ? response.data.data.telco : null } ; 
                    ;`
        
        


        this.dataStore(msg)
        window.location.href = '/'

        // let urlCurrent = window.location.href;
        // if(urlCurrent.includes("he.mjunoon.tv")){
        //   window.location.href = "https://bd.mjunoon.tv/?msisdn="+ LocalStorageService.encryptAes(this.state.loginmobilenumber)
        // }
        // else{
        //   window.location.href = "/?msisdn="+ LocalStorageService.encryptAes(this.state.loginmobilenumber)
        // }

      }
      else{
        UIkit.modal("#modal-login").hide();

        console.log(response.data)
        
        swal({
          icon : "error" ,
          text : response.data.message
        })
        // localStorage.setItem('uid', 43);
        // window.location.href = "/psl-9"
      
      }
    }  )

  };

  // callloginapi = () => {

  //   console.log('TEst')
  //   axios({
  //     method :"POST" ,
  //     url : Constant.url + "login-bd" ,
  //     data : {
  //     mobile : this.state.loginmobilenumber,
  //     }
  //   }).then((res) =>{
  //     console.log(res.data)

  //     let response = [];
  //     response["data"] = JSON.parse(
  //       LocalStorageService.decryptAes(res.data.eData)
  //     );
  //     if(response.data.code === 200){  
  //     const msg =  `device_id : ${response.data.data.device_id} ; 
  //                   phone_details : ${response.data.data.phone_details};
  //                   user_id : ${response.data.data.uid} ; 
  //                   mobile : ${response.data.data.mobile} ;
  //                   package_id : ${response.data.data.package_id};
  //                   subscription_expiry_datetime:  ${response.data.data.subscription_expiry_datetime} ;`
        
  //       let urlCurrent = window.location.href;
  //       if(urlCurrent.includes("he.mjunoon.tv")){
  //         window.location.href = "https://bd.mjunoon.tv/?msisdn="+ LocalStorageService.encryptAes(this.state.loginmobilenumber)
  //       }
  //       else{
  //         window.location.href = "/?msisdn="+ LocalStorageService.encryptAes(this.state.loginmobilenumber)
  //       }

  //     }
  //     else{
  //       console.log(response.data)
  //       swal({
  //         icon : "error" ,
  //         text : response.data.message
  //       })
  //     }
  //   }  )

  // };

  // this function is after redirecting from grameen registeration page 
  callloginapi2 = (decrypted) => {
    axios({
      method :"POST" ,
      url : Constant.url + "login-bd" ,
      data : {
      mobile : decrypted.msisdn ,
      }
    }).then((res) =>{
      // console.log(this.state.loginmobilenumber)
      let response = [];
      response["data"] = JSON.parse(
        LocalStorageService.decryptAes(res.data.eData)
      );
      if(response.data.code === 200){
        const msg =  `device_id : ${response.data.data.device_id} ; 
        phone_details : ${response.data.data.phone_details};
        user_id : ${response.data.data.uid} ; 
        mobile', ${response.data.data.mobile} ;
        package_id', ${response.data.data.package_id};
        subscription_expiry_datetime:  ${response.data.data.subscription_expiry_datetime};
        telco : ${response.data.data.telco ? response.data.data.telco : null } ;
        `
        
        // this.dataStore(msg)

        // localStorage.setItem('user_id', response.data.data.uid);
        // localStorage.setItem('mobile', response.data.data.mobile);
        // localStorage.setItem('package_id', response.data.data.package_id);

        // localStorage.setItem('subscription_expiry_datetime', response.data.data.subscription_expiry_datetime);

        let urlCurrent = window.location.href;
        if(urlCurrent.includes("he.mjunoon.tv")){
          window.location.href = "https://bd.mjunoon.tv/?msisdn="+ LocalStorageService.encryptAes(this.state.loginmobilenumber)
        }
        else{
          window.location.href = "/?msisdn="+ LocalStorageService.encryptAes(this.state.loginmobilenumber)
        }
      }
      else{
        console.log("inside 400 callloginapi2 ")
        swal({
          icon : "error" ,
          text : "something went wrong, please try again later!"
        })
        // localStorage.setItem('uid', 43);
        // window.location.href = "/psl-9"
      
      }
    }  )

  };




  // retreive packages from api
  getPackages = () => {
    // request to api to fetch packages
    let classRef = this;

  };



  getUserNumber = () => {

    let classRef = this;
    axios({
      method: "GET",
      url: "http://ibadat.co/digi.msisdn.get.app",
    })
      .then((response) => {
        if (response.status === 200) {
          const responseData = response.data; // Assuming 'data' key contains the API response data
          // console.log('response data' , res)
          if (responseData === "could not track") {
            
            console.log(responseData);
            this.setState({ phoneNumber: "" });
          } else {
            const url = new URL(window.location.href);
            const clickId = url.searchParams.get('click_id');
            const aff_id = url.searchParams.get('aff_id');

            if(clickId){
              axios({
                method:"post",
                url :'https://cdn2.mjunoon.tv:9191/v2/tracking-bd?msisdn='+responseData+'&aff_id='+aff_id+'&click_id='+clickId+'',
              })  
            }
                   

            this.setState({ phoneNumber: responseData , loginmobilenumber: responseData });

            // axios({
            //   method: "POST",
            //   url: Constant.url + "getsubs-bd",
            //   data: {
            //     serviceId: this.state.selectedPackage,
            //     msisdn: this.state.phoneNumber,
            //     base_url : Constant.subscription_url +'/register'
                
            //   },
            //   headers: {
            //     Authorization: "bearer " + localStorage.getItem("access_token"),
            //   },
            //   timeout: 20000,
            // }).then( (result)=> {
            //   classRef.setState({ isDisabled: false });
            //   if (result.status === 200) {
            //     let response = {};
            //     response["data"] = JSON.parse(
            //       LocalStorageService.decryptAes(result.data.eData)
            //     );
            //     classRef.myForm.reset();
      
            //     if(response.data.code === 200){
            //       window.location.href = (response.data.data);
            //     }
                
            //     else if(response.data.code === 202) {
            //       swal({
            //         icon: "success",
            //         title: "Login Successful",
            //       }).then( () => {
            //         console.log("test by yaseen",response.data.data.uid);
            //         const msg =  `device_id : ${response.data.data.device_id} ; 
            //               phone_details : ${response.data.data.phone_details};
            //               user_id : ${response.data.data.uid} ; 
            //               mobile : ${response.data.data.mobile} ;
            //               package_id : ${response.data.data.package_id};
            //               subscription_expiry_datetime:  ${response.data.data.subscription_expiry_datetime} ;`
              
            //         // this.dataStore(msg)
            //         window.location.href = "https://bd.mjunoon.tv/?msisdn="+ LocalStorageService.encryptAes(response.data.data.mobile)
                    
      
            //       } )
            //     }
      
            //     else {
            //       swal({
            //         icon: "error",
            //         title: "Error",
            //         text: response.data.message,
            //       })
            //     }
                
            //   }
            //   if (result.status === 400) {
            //     console.log("subscription api response failed");
            //   }
            // });
            
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  signinform = () => {
    UIkit.modal("#modal-login").show();
  };



  setmobilenumber = (e) => {

    // regex to let user write numbers only 

    if (/^\+?\d*$/.test(e.target.value)) {
      this.setState({ loginmobilenumber: e.target.value });
  }
  };






  checkUrl = () => {
    // Get the query string from the URL
    const queryString = window.location.search;

    // Function to parse the query string and extract parameter values
    const getQueryParamValue = (queryString, paramName) => {
      const params = new URLSearchParams(queryString);
      return params.get(paramName);
    };
    
    // Get the value of the 'res' parameter
    const resValue = getQueryParamValue(queryString, 'res');

    if(resValue !== null && resValue !== undefined){
    // safe site state 
    this.setState({iframe : resValue});
      const decryptedval = JSON.parse(LocalStorageService.decryptAes(resValue));

    console.log(decryptedval)      
        if (decryptedval.status === "200") {
          this.setState({
            loginmobilenumber: decryptedval.msisdn
          });
          console.log("mobile after state set", this.state.loginmobilenumber)

          // axios({
          //   method: "GET",
          //   url: "https://cdn2.mjunoon.tv:9191/v2/get-tracking-bd?msisdn="+this.state.loginmobilenumber+"",
          // })
          //   .then((response) => {
          //     if (response.status === 200) {
          //       this.setState({
          //         click_id: response.data.data.click_id
          //       });
                
          //       // axios({
          //       //   method: "GET",
          //       //   url: "https://digitantra86.trackier.co/acquisition?click_id="+this.state.click_id+"&security_token=60469c2450e2e424019d",
          //       // })
          //       axios({
          //         method: "POST",
          //         url: "https://cdn2.mjunoon.tv:9191/v2/tracking-bd-logs",
          //         data: {click_id : this.state.click_id}
          //       })
          //     }
          // });

          axios({
              method: "POST",
              url: "https://cdn2.mjunoon.tv:9191/v2/tracking-bd-logs",
              data: {mobile : this.state.loginmobilenumber}
          })



          swal({
            icon: "success",
            title: "success",
            text: "Payment Success",
          }).then(() => {
            this.callloginapi2(decryptedval);
          });
        } 
        
        else if (decryptedval.status === "402") {
          swal({
            icon: "error",
            title: "Failed",
            text: "Payment Deny",
          });
        } else if (decryptedval.status === "400") {
          swal({
            icon: "error",
            title: "Failed",
            text: "Payment Failed",
          });
        } else {
          swal({
            icon: "error",
            title: "error",
            text: "Payment Failed",
            confirmButtonText: "OK",
          });
        }
        

    }
    else{
      return
    }

    }

  render() {
    return this.state.isLoading ? (
      <Loader />
    ) : (
      <>
        {/* modals */}

        <div id="modal-iframe" uk-modal="true">
          <div className="uk-modal-dialog uk-modal-body">
            <button
              className="uk-modal-close-default"
              type="button"
              uk-close="true"
            ></button>
            <iframe
              src={this.state.embededUrl}
              title="Embedded Website"
              width="100%"
              height="500px"
            ></iframe>
          </div>
        </div>

        

        <div id="modal-login" uk-modal="true">
          <div
            className="uk-modal-dialog uk-modal-body uk-margin-auto-vertical uk-box-shadow-xlarge formbox  "
            style={{
              background:"img/formbox.png", 
              backgroundColor: "#23262c",
              width: "530px",
              borderRadius: "14px",
            }}
          >

            <button
              className="uk-modal-close-default"
              type="button"
              uk-close="true"
            ></button>

            <div className="loginform ">
              {" "}
              <form onSubmit={this.callloginapi} style={{ height: "400px" }}>
                <img src="img/formlogo.png" />
                <h1 style={{ color: "#B066FE", fontWeight: "600" }}>
                  LOGIN
                </h1>{" "}

                {/* login form input */}
                <input
                  required
                  value={this.state.loginmobilenumber}
                  onChange={this.setmobilenumber}
                  placeholder="Mobile Number....."
                  className="uk-input forminput"
                  pattern="^8801[3,6,7,8][0-9]{8}$"
                  title="Enter a valid Bangladeshi phone number"
                  type="text"
                  maxlength="13"
                ></input>
                <button
                  className="uk-button loginbtn "
                  type="submit"
                  style={{ marginTop: "20px", backgroundColor: "#B066FE" }}
                >
                  Login
                </button>
              </form>
            </div>
          </div>
        </div>



        

       


       
        {/*  */}

        <header className="landing-header">
          <div className="container">
            <div>
              <Link to="/">
                {" "}
                <img
                  className="img-logo"
                  src="/images/logo.webp"
                  alt="mJunoon.tv"
                />
              </Link>
            </div>
            <div className="mobileList">
              <ul className="list-inline">
                <li className="list-inline-item">
                  <span className="download">Download App</span>
                </li>
                <li className="list-inline-item">
                  <a
                    target="_blank"
                    href="https://appgallery.huawei.com/#/app/C100874529"
                  >
                    <img
                      className="img-store-icons"
                      src="/images/Badge-Black@3x.png"
                      alt="Mjunoon Huawei App"
                    />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    target="_blank"
                    href="https://play.google.com/store/apps/details?id=com.convex.mjunoon.TV&amp;hl=en"
                  >
                    <img
                      className="img-store-icons"
                      src="/images/googleplay.png"
                      alt="Mjunoon Huawei App"
                    />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    target="_blank"
                    href="https://itunes.apple.com/us/app/mjunoon-tv/id1107354784?mt=8"
                  >
                    <img
                      className="img-store-icons"
                      src="/images/apstore.png"
                      alt="Mjunoon IOS App"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </header>
        <main>
          <section className="banner-landing">
            {isMobile ? (
              <>
                <img src="/images/bdmobile.png" />
                <div className="landinghead">
                  <h1>Unlimited Entertainment</h1>
                  <h2>Awaits You!</h2>
                  
                </div>
              </>
            ) : (
              <img src="/images/bdlanding.png" />
            )}
          </section>

          <section className="packages-section">
            <div className="container">
              <div>{/* <h1>আপনার প্যাকেজ নির্বাচন করুন</h1> */}</div>
              <form
                ref={(form) => (this.myForm = form)}
                className="form-package"
                onSubmit={this.handleSubmit}
                encType="multipart/form-data"
              >
                <div className="mx-auto text-center card-details-box">
                  {/* <h2>আপনার মোবাইল নাম্বার প্রবেশ করুন</h2> */}

                  <div className="form-box" >
                          {isMobile ? (
                      <>
                        <div className="" style={{textAlign:"left" , margin:0 , padding:'10px 0 ' , }}>
                          <h2 style={{margin:0 , color:'#b066fe'}}>New User</h2>
                        </div>
                      </>
                    ) : (
                      ''
                    )}
                    <select
                      value={this.state.telco}
                      aria-label="Custom controls"
                      onChange={(e) => {
                        this.setState({ telco: e.target.value });
                        
                      }}
                    >
                      <option value=""> Payment Option </option>
                      <option value="grameen">Grameenphone</option>
                      <option value="robi">Robi-Airtel</option>
                    </select>

                    <input
                      id="phoneBn"
                      name="phoneBn"
                      type="text"
                      required
                      pattern= { this.state.telco === 'grameen' ?  "^8801[73][0-9]{8}$" : "^8801[86][0-9]{8}$" }
                      title={ this.state.telco === 'grameen' ?  "Enter a Valid Grameen Number" : this.state.telco === 'Robi' ? "Enter a Valid Robi Number" : "Enter a Valid Bangladeshi Number" }
                      placeholder="880xxxxxxxx"
                      value={this.state.phoneNumber}
                      onChange={this.handleNumberChange}
                      maxLength="13"
                    />

                    {this.state.isDisabled ? (
                      <img
                        className="loader-form"
                        src="/images/landing/giphy.gif"
                        width={"20px"}
                        height={"20px"}
                      />
                    ) : (
                      <>
                        <button
                          className="form-submit"
                          type="submit"
                          disabled={this.state.isDisabled}
                        >
                          Continue
                        </button>
                      </>
                    )}
                    <p className="uk-text-large 	">
                      Already Registered ?{" "}
                      <a onClick={this.signinform}> Login </a>{" "}
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </section>
        </main>
      </>
    );
  }
}

export default GrameenBangladesh;
